import React from 'react'
import "../../css/style.css";

export default function heading(props) {
  return (
    <h2 className='main-head'><span className='b'>{props.text}</span></h2>
  )
}
